import React from "react";
import { Card, Typography, Tooltip, Statistic } from "antd";
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { motion } from "framer-motion";

const { Text } = Typography;

const PromotionStatsCard = ({
  title,
  value,
  prefix,
  suffix,
  icon,
  color = "#1890ff",
  backgroundColor = "#e6f7ff",
  trend,
  trendLabel,
  loading = false,
  tooltip,
  onClick,
  style = {},
}) => {
  const isPositiveTrend = trend > 0;
  const hasTrend = trend !== undefined && trend !== null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      whileHover={{ scale: onClick ? 1.02 : 1 }}
      style={{ height: "100%" }}
    >
      <Card
        bordered={false}
        hoverable={!!onClick}
        onClick={onClick}
        loading={loading}
        style={{
          background: backgroundColor,
          borderLeft: `4px solid ${color}`,
          height: "100%",
          cursor: onClick ? "pointer" : "default",
          ...style,
        }}
        bodyStyle={{ padding: "16px 20px" }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
          }}
        >
          <div style={{ flex: 1 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 8,
              }}
            >
              <Text
                type="secondary"
                style={{
                  fontSize: 13,
                  fontWeight: 500,
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                {title}
              </Text>
              {tooltip && (
                <Tooltip title={tooltip}>
                  <InfoCircleOutlined
                    style={{
                      marginLeft: 6,
                      fontSize: 12,
                      color: "#8c8c8c",
                      cursor: "help",
                    }}
                  />
                </Tooltip>
              )}
            </div>

            <Statistic
              value={value}
              prefix={prefix}
              suffix={suffix}
              valueStyle={{
                fontSize: 28,
                fontWeight: 700,
                color: color,
                lineHeight: 1.2,
              }}
            />

            {hasTrend && (
              <div style={{ marginTop: 8, display: "flex", alignItems: "center" }}>
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "2px 8px",
                    borderRadius: 12,
                    fontSize: 12,
                    fontWeight: 600,
                    backgroundColor: isPositiveTrend
                      ? "rgba(82, 196, 26, 0.1)"
                      : "rgba(255, 77, 79, 0.1)",
                    color: isPositiveTrend ? "#52c41a" : "#ff4d4f",
                  }}
                >
                  {isPositiveTrend ? (
                    <ArrowUpOutlined style={{ marginRight: 4 }} />
                  ) : (
                    <ArrowDownOutlined style={{ marginRight: 4 }} />
                  )}
                  {Math.abs(trend).toFixed(1)}%
                </span>
                {trendLabel && (
                  <Text
                    type="secondary"
                    style={{ marginLeft: 8, fontSize: 12 }}
                  >
                    {trendLabel}
                  </Text>
                )}
              </div>
            )}
          </div>

          {icon && (
            <div
              style={{
                width: 48,
                height: 48,
                borderRadius: 12,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: `${color}20`,
                color: color,
                fontSize: 24,
              }}
            >
              {icon}
            </div>
          )}
        </div>
      </Card>
    </motion.div>
  );
};

export default PromotionStatsCard;
